const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  COGNITO_CONFIGURATION: {
    authority: process.env.REACT_APP_COGNITO_AUTHORITY,
    client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
    response_type: "code",
    scope: "email openid phone",
  },
};

export default config;
